// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-portfolio-portfolio-detail-tab-documents-header-DocumentsHeader-module__root--3Q9dR"};